{
  "familyId": "TGL-GELD-BTW",
  "questions": [
    {
      "id": "TGL-GELD-BTW-001",
      "familyId": "TGL-GELD-BTW",
      "module": "TGL",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_btw",
      "questionType": "multiple_choice",
      "question": "Een artikel kost €100 exclusief BTW. Met 21% BTW erbij, wat is de prijs inclusief BTW?",
      "options": [
        "€121",
        "€21",
        "€79",
        "€100,21"
      ],
      "correctAnswer": 0,
      "conceptId": "btw_excl_to_incl_21pct",
      "variantIndex": 1,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "BTW berekenen (21%)",
            "content": "Bereken eerst de BTW: 21% van €100 = 0,21 × €100 = €21. Tel de BTW bij de prijs: €100 + €21 = €121. De prijs inclusief BTW is €121."
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Strategie: prijs inclusief BTW = prijs exclusief + BTW-bedrag. Stap 1: bereken de BTW: 21% van €100 = 0,21 × €100 = €21. Stap 2: tel op: €100 + €21 = €121.",
        "distractorExplanations": {
          "0": "Correct! €100 + 21% BTW (€21) = €121.",
          "1": "Veelgemaakte fout: het BTW-bedrag verwarren met de totaalprijs. €21 is alleen de BTW. Je moet dit bij de prijs optellen: €100 + €21 = €121.",
          "2": "Veelgemaakte fout: aftrekken in plaats van optellen. Bij 'inclusief BTW' tel je de BTW erbij op, niet eraf. €100 + €21 = €121, niet €100 − €21 = €79.",
          "3": "Veelgemaakte fout: het percentage als bedrag in centen zien. 21% is niet €0,21 maar 0,21 × de prijs. 0,21 × €100 = €21."
        }
      }
    },
    {
      "id": "TGL-GELD-BTW-002",
      "familyId": "TGL-GELD-BTW",
      "module": "TGL",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_btw",
      "questionType": "multiple_choice",
      "question": "Een boek kost €50 exclusief BTW. Met 9% BTW erbij, wat is de prijs inclusief BTW?",
      "options": [
        "€54,50",
        "€4,50",
        "€45,50",
        "€59"
      ],
      "correctAnswer": 0,
      "conceptId": "btw_excl_to_incl_9pct",
      "variantIndex": 2,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "BTW berekenen (9%)",
            "content": "Bereken eerst de BTW: 9% van €50 = 0,09 × €50 = €4,50. Tel de BTW bij de prijs: €50 + €4,50 = €54,50. De prijs inclusief BTW is €54,50."
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Strategie: prijs inclusief BTW = prijs exclusief + BTW-bedrag. Stap 1: bereken de BTW: 9% van €50 = 0,09 × €50 = €4,50. Stap 2: tel op: €50 + €4,50 = €54,50.",
        "distractorExplanations": {
          "0": "Correct! €50 + 9% BTW (€4,50) = €54,50.",
          "1": "Veelgemaakte fout: het BTW-bedrag verwarren met de totaalprijs. €4,50 is alleen de BTW. Je moet dit bij de prijs optellen: €50 + €4,50 = €54,50.",
          "2": "Veelgemaakte fout: aftrekken in plaats van optellen. Bij 'inclusief BTW' tel je de BTW erbij op: €50 + €4,50 = €54,50, niet €50 − €4,50 = €45,50.",
          "3": "Veelgemaakte fout: het percentage als vast bedrag zien. 9% van €50 is €4,50, niet €9. Reken: 0,09 × €50 = €4,50."
        }
      }
    },
    {
      "id": "TGL-GELD-BTW-003",
      "familyId": "TGL-GELD-BTW",
      "module": "TGL",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_btw",
      "questionType": "multiple_choice",
      "question": "Een telefoon kost €121 inclusief 21% BTW. Wat is de prijs exclusief BTW?",
      "options": [
        "€100",
        "€96,80",
        "€142",
        "€101"
      ],
      "correctAnswer": 0,
      "conceptId": "btw_incl_to_excl_21pct",
      "variantIndex": 3,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "BTW terugrekenen (21%)",
            "content": "Bij 21% BTW is de prijs inclusief BTW 121% van de oorspronkelijke prijs. Deel door 1,21: €121 ÷ 1,21 = €100. De prijs exclusief BTW is €100."
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Strategie: bij BTW terugrekenen deel je door 1 + het BTW-percentage als decimaal. Stap 1: 21% BTW → deel door 1,21. Stap 2: €121 ÷ 1,21 = €100. De prijs exclusief BTW is €100. Controle: €100 × 1,21 = €121 ✓.",
        "distractorExplanations": {
          "0": "Correct! €121 ÷ 1,21 = €100.",
          "1": "Veelgemaakte fout: 21% van het inclusief-bedrag aftrekken. 21% van €121 = €25,41, dus €121 − €25,41 = €95,59 ≈ €96,80. Maar dit is fout! Je moet delen door 1,21: €121 ÷ 1,21 = €100.",
          "2": "Veelgemaakte fout: optellen in plaats van terugrekenen. Bij 'exclusief BTW' reken je de BTW eruit, niet erbij. Deel door 1,21.",
          "3": "Veelgemaakte fout: een vast bedrag (€21) aftrekken. €121 − €21 = €100 klopt hier toevallig, maar de juiste methode is delen door 1,21."
        }
      }
    },
    {
      "id": "TGL-GELD-BTW-004",
      "familyId": "TGL-GELD-BTW",
      "module": "TGL",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_btw",
      "questionType": "multiple_choice",
      "question": "Een artikel kost €200 exclusief BTW. Hoeveel BTW betaal je bij 21%?",
      "options": [
        "€42",
        "€21",
        "€158",
        "€242"
      ],
      "correctAnswer": 0,
      "conceptId": "btw_amount_21pct",
      "variantIndex": 4,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "BTW-bedrag berekenen",
            "content": "Bereken 21% van €200: 0,21 × €200 = €42. Je betaalt €42 aan BTW."
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Strategie: BTW-bedrag = percentage × prijs ÷ 100. Stap 1: 21% van €200 = 0,21 × €200 = €42. Je betaalt €42 aan BTW.",
        "distractorExplanations": {
          "0": "Correct! 21% van €200 = €42 aan BTW.",
          "1": "Veelgemaakte fout: het percentage op €100 berekenen in plaats van op het werkelijke bedrag. €21 = 21% van €100, maar de prijs is €200. Reken: 0,21 × €200 = €42.",
          "2": "Veelgemaakte fout: de prijs exclusief BTW verwarren met het BTW-bedrag. €158 = €200 − €42 (de prijs na aftrek). De vraag is hoeveel BTW je betaalt: €42.",
          "3": "Veelgemaakte fout: de prijs inclusief BTW verwarren met het BTW-bedrag. €242 = €200 + €42 (de totaalprijs). De vraag is alleen hoeveel BTW: €42."
        }
      }
    },
    {
      "id": "TGL-GELD-BTW-005",
      "familyId": "TGL-GELD-BTW",
      "module": "TGL",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_btw",
      "questionType": "multiple_choice",
      "question": "Een maaltijd kost €54,50 inclusief 9% BTW. Wat is de prijs exclusief BTW?",
      "options": [
        "€50",
        "€49,60",
        "€59,40",
        "€45,50"
      ],
      "correctAnswer": 0,
      "conceptId": "btw_incl_to_excl_9pct",
      "variantIndex": 5,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "BTW terugrekenen (9%)",
            "content": "Bij 9% BTW is de prijs inclusief BTW 109% van de oorspronkelijke prijs. Deel door 1,09: €54,50 ÷ 1,09 = €50. De prijs exclusief BTW is €50."
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Strategie: bij BTW terugrekenen deel je door 1 + het BTW-percentage als decimaal. Stap 1: 9% BTW → deel door 1,09. Stap 2: €54,50 ÷ 1,09 = €50. De prijs exclusief BTW is €50. Controle: €50 × 1,09 = €54,50 ✓.",
        "distractorExplanations": {
          "0": "Correct! €54,50 ÷ 1,09 = €50.",
          "1": "Veelgemaakte fout: 9% van het inclusief-bedrag aftrekken. 9% van €54,50 = €4,91, dus €54,50 − €4,91 = €49,59 ≈ €49,60. Maar dit is fout! Je moet delen door 1,09: €54,50 ÷ 1,09 = €50.",
          "2": "Veelgemaakte fout: optellen in plaats van terugrekenen. Bij 'exclusief BTW' reken je de BTW eruit, niet erbij.",
          "3": "Veelgemaakte fout: te veel aftrekken. €45,50 = €54,50 − €9, maar 9% van €54,50 is niet €9. Deel door 1,09: €54,50 ÷ 1,09 = €50."
        }
      }
    },
    {
      "id": "TGL-GELD-BTW-006",
      "familyId": "TGL-GELD-BTW",
      "module": "TGL",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_btw",
      "questionType": "multiple_choice",
      "question": "Een fiets kost €150 exclusief BTW. Met 21% BTW erbij, wat is de prijs inclusief BTW?",
      "options": [
        "€181,50",
        "€31,50",
        "€118,50",
        "€171"
      ],
      "correctAnswer": 0,
      "conceptId": "btw_excl_to_incl_21pct_large",
      "variantIndex": 6,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "BTW berekenen (21%)",
            "content": "Bereken eerst de BTW: 21% van €150 = 0,21 × €150 = €31,50. Tel de BTW bij de prijs: €150 + €31,50 = €181,50. De prijs inclusief BTW is €181,50."
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Strategie: prijs inclusief BTW = prijs exclusief + BTW-bedrag. Stap 1: bereken de BTW: 21% van €150 = 0,21 × €150 = €31,50. Stap 2: tel op: €150 + €31,50 = €181,50.",
        "distractorExplanations": {
          "0": "Correct! €150 + 21% BTW (€31,50) = €181,50.",
          "1": "Veelgemaakte fout: het BTW-bedrag verwarren met de totaalprijs. €31,50 is alleen de BTW. Je moet dit bij de prijs optellen: €150 + €31,50 = €181,50.",
          "2": "Veelgemaakte fout: aftrekken in plaats van optellen. Bij 'inclusief BTW' tel je de BTW erbij op: €150 + €31,50 = €181,50, niet €150 − €31,50 = €118,50.",
          "3": "Veelgemaakte fout: het percentage als vast bedrag zien. 21% van €150 is €31,50, niet €21. Reken: 0,21 × €150 = €31,50."
        }
      }
    },
    {
      "id": "TGL-GELD-BTW-007",
      "familyId": "TGL-GELD-BTW",
      "module": "TGL",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_btw",
      "questionType": "multiple_choice",
      "question": "Een dienst kost €80 exclusief BTW. Hoeveel BTW betaal je bij 21%?",
      "options": [
        "€16,80",
        "€21",
        "€63,20",
        "€96,80"
      ],
      "correctAnswer": 0,
      "conceptId": "btw_amount_21pct_80",
      "variantIndex": 7,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "BTW-bedrag berekenen",
            "content": "Bereken 21% van €80: 0,21 × €80 = €16,80. Je betaalt €16,80 aan BTW."
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Strategie: BTW-bedrag = percentage × prijs ÷ 100. Stap 1: 21% van €80 = 0,21 × €80 = €16,80. Je betaalt €16,80 aan BTW.",
        "distractorExplanations": {
          "0": "Correct! 21% van €80 = €16,80 aan BTW.",
          "1": "Veelgemaakte fout: het percentage op €100 berekenen in plaats van op het werkelijke bedrag. €21 = 21% van €100, maar de prijs is €80. Reken: 0,21 × €80 = €16,80.",
          "2": "Veelgemaakte fout: de prijs exclusief BTW verwarren met het BTW-bedrag. €63,20 = €80 − €16,80 (de prijs na aftrek). De vraag is hoeveel BTW: €16,80.",
          "3": "Veelgemaakte fout: de prijs inclusief BTW verwarren met het BTW-bedrag. €96,80 = €80 + €16,80 (de totaalprijs). De vraag is alleen hoeveel BTW: €16,80."
        }
      }
    },
    {
      "id": "TGL-GELD-BTW-008",
      "familyId": "TGL-GELD-BTW",
      "module": "TGL",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_btw",
      "questionType": "multiple_choice",
      "question": "Een product kost €242 inclusief 21% BTW. Wat is de prijs exclusief BTW?",
      "options": [
        "€200",
        "€191,60",
        "€263",
        "€221"
      ],
      "correctAnswer": 0,
      "conceptId": "btw_incl_to_excl_21pct_large",
      "variantIndex": 8,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "BTW terugrekenen (21%)",
            "content": "Bij 21% BTW is de prijs inclusief BTW 121% van de oorspronkelijke prijs. Deel door 1,21: €242 ÷ 1,21 = €200. De prijs exclusief BTW is €200."
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Strategie: bij BTW terugrekenen deel je door 1 + het BTW-percentage als decimaal. Stap 1: 21% BTW → deel door 1,21. Stap 2: €242 ÷ 1,21 = €200. De prijs exclusief BTW is €200. Controle: €200 × 1,21 = €242 ✓.",
        "distractorExplanations": {
          "0": "Correct! €242 ÷ 1,21 = €200.",
          "1": "Veelgemaakte fout: 21% van het inclusief-bedrag aftrekken. 21% van €242 = €50,82, dus €242 − €50,82 = €191,18 ≈ €191,60. Maar dit is fout! Je moet delen door 1,21: €242 ÷ 1,21 = €200.",
          "2": "Veelgemaakte fout: optellen in plaats van terugrekenen. Bij 'exclusief BTW' reken je de BTW eruit, niet erbij.",
          "3": "Veelgemaakte fout: een vast bedrag (€21) aftrekken. €242 − €21 = €221, maar de BTW is niet €21 — het is 21% van de prijs exclusief BTW. Deel door 1,21: €242 ÷ 1,21 = €200."
        }
      }
    },
    {
      "id": "TGL-GELD-BTW-009",
      "familyId": "TGL-GELD-BTW",
      "module": "TGL",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_btw",
      "questionType": "multiple_choice",
      "question": "Een artikel kost €40 exclusief BTW. Met 9% BTW erbij, wat is de prijs inclusief BTW?",
      "options": [
        "€43,60",
        "€3,60",
        "€36,40",
        "€49"
      ],
      "correctAnswer": 0,
      "conceptId": "btw_excl_to_incl_9pct_40",
      "variantIndex": 9,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "BTW berekenen (9%)",
            "content": "Bereken eerst de BTW: 9% van €40 = 0,09 × €40 = €3,60. Tel de BTW bij de prijs: €40 + €3,60 = €43,60. De prijs inclusief BTW is €43,60."
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Strategie: prijs inclusief BTW = prijs exclusief + BTW-bedrag. Stap 1: bereken de BTW: 9% van €40 = 0,09 × €40 = €3,60. Stap 2: tel op: €40 + €3,60 = €43,60.",
        "distractorExplanations": {
          "0": "Correct! €40 + 9% BTW (€3,60) = €43,60.",
          "1": "Veelgemaakte fout: het BTW-bedrag verwarren met de totaalprijs. €3,60 is alleen de BTW. Je moet dit bij de prijs optellen: €40 + €3,60 = €43,60.",
          "2": "Veelgemaakte fout: aftrekken in plaats van optellen. Bij 'inclusief BTW' tel je de BTW erbij op: €40 + €3,60 = €43,60, niet €40 − €3,60 = €36,40.",
          "3": "Veelgemaakte fout: het percentage als vast bedrag zien. 9% van €40 is €3,60, niet €9. Reken: 0,09 × €40 = €3,60."
        }
      }
    },
    {
      "id": "TGL-GELD-BTW-010",
      "familyId": "TGL-GELD-BTW",
      "module": "TGL",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_btw",
      "questionType": "multiple_choice",
      "question": "Een dienst kost €109 inclusief 9% BTW. Wat is de prijs exclusief BTW?",
      "options": [
        "€100",
        "€99,20",
        "€118",
        "€90"
      ],
      "correctAnswer": 0,
      "conceptId": "btw_incl_to_excl_9pct_109",
      "variantIndex": 10,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "BTW terugrekenen (9%)",
            "content": "Bij 9% BTW is de prijs inclusief BTW 109% van de oorspronkelijke prijs. Deel door 1,09: €109 ÷ 1,09 = €100. De prijs exclusief BTW is €100."
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Strategie: bij BTW terugrekenen deel je door 1 + het BTW-percentage als decimaal. Stap 1: 9% BTW → deel door 1,09. Stap 2: €109 ÷ 1,09 = €100. De prijs exclusief BTW is €100. Controle: €100 × 1,09 = €109 ✓.",
        "distractorExplanations": {
          "0": "Correct! €109 ÷ 1,09 = €100.",
          "1": "Veelgemaakte fout: 9% van het inclusief-bedrag aftrekken. 9% van €109 = €9,81, dus €109 − €9,81 = €99,19 ≈ €99,20. Maar dit is fout! Je moet delen door 1,09: €109 ÷ 1,09 = €100.",
          "2": "Veelgemaakte fout: optellen in plaats van terugrekenen. Bij 'exclusief BTW' reken je de BTW eruit, niet erbij.",
          "3": "Veelgemaakte fout: te veel aftrekken. €90 = €109 − €19, maar 9% van €109 is niet €19. Deel door 1,09: €109 ÷ 1,09 = €100."
        }
      }
    },
    {
      "id": "TGL-GELD-BTW-011",
      "familyId": "TGL-GELD-BTW",
      "module": "TGL",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_btw",
      "questionType": "multiple_choice",
      "question": "Een laptop kost €500 exclusief BTW. Hoeveel BTW betaal je bij 21%?",
      "options": [
        "€105",
        "€21",
        "€395",
        "€605"
      ],
      "correctAnswer": 0,
      "conceptId": "btw_amount_21pct_500",
      "variantIndex": 11,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "BTW-bedrag berekenen",
            "content": "Bereken 21% van €500: 0,21 × €500 = €105. Je betaalt €105 aan BTW."
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Strategie: BTW-bedrag = percentage × prijs ÷ 100. Stap 1: 21% van €500 = 0,21 × €500 = €105. Je betaalt €105 aan BTW.",
        "distractorExplanations": {
          "0": "Correct! 21% van €500 = €105 aan BTW.",
          "1": "Veelgemaakte fout: het percentage op €100 berekenen in plaats van op het werkelijke bedrag. €21 = 21% van €100, maar de prijs is €500. Reken: 0,21 × €500 = €105.",
          "2": "Veelgemaakte fout: de prijs exclusief BTW verwarren met het BTW-bedrag. €395 = €500 − €105 (de prijs na aftrek). De vraag is hoeveel BTW: €105.",
          "3": "Veelgemaakte fout: de prijs inclusief BTW verwarren met het BTW-bedrag. €605 = €500 + €105 (de totaalprijs). De vraag is alleen hoeveel BTW: €105."
        }
      }
    },
    {
      "id": "TGL-GELD-BTW-012",
      "familyId": "TGL-GELD-BTW",
      "module": "TGL",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_btw",
      "questionType": "multiple_choice",
      "question": "Een reparatie kost €87,20 inclusief 9% BTW. Wat is de prijs exclusief BTW?",
      "options": [
        "€80",
        "€79,35",
        "€95,05",
        "€78,20"
      ],
      "correctAnswer": 0,
      "conceptId": "btw_incl_to_excl_9pct_87",
      "variantIndex": 12,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "BTW terugrekenen (9%)",
            "content": "Bij 9% BTW is de prijs inclusief BTW 109% van de oorspronkelijke prijs. Deel door 1,09: €87,20 ÷ 1,09 = €80. De prijs exclusief BTW is €80."
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Strategie: bij BTW terugrekenen deel je door 1 + het BTW-percentage als decimaal. Stap 1: 9% BTW → deel door 1,09. Stap 2: €87,20 ÷ 1,09 = €80. De prijs exclusief BTW is €80. Controle: €80 × 1,09 = €87,20 ✓.",
        "distractorExplanations": {
          "0": "Correct! €87,20 ÷ 1,09 = €80.",
          "1": "Veelgemaakte fout: 9% van het inclusief-bedrag aftrekken. 9% van €87,20 = €7,85, dus €87,20 − €7,85 = €79,35. Maar dit is fout! Je moet delen door 1,09: €87,20 ÷ 1,09 = €80.",
          "2": "Veelgemaakte fout: optellen in plaats van terugrekenen. Bij 'exclusief BTW' reken je de BTW eruit, niet erbij.",
          "3": "Veelgemaakte fout: te veel aftrekken. €78,20 = €87,20 − €9, maar 9% van €87,20 is niet €9. Deel door 1,09: €87,20 ÷ 1,09 = €80."
        }
      }
    }
  ]
}